// extracted by mini-css-extract-plugin
export default {"content":"SubmissionResult_content__dRaij","title":"SubmissionResult_title__+Px9x","button":"SubmissionResult_button__8A-gp"};